<template>
  <div>
    <base-flex-spinner v-if="loading" />
    <div v-else class="space-y-4">
      <ApplicationMobileHeader />
      <div class="px-4 space-y-4">
        <CustomerApplicationMobileAttachmentsBanner />
        <div class="flex gap-8">
          <CertifiedCustomerCountCard v-if="meta?.total" :count="meta.total" class="flex-1" />
          <PendingUserCountCard v-if="uncertifiedCustomers?.length" :count="uncertifiedCustomers.length" class="flex-1" />
        </div>
        <TodayCustomersDatatable />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import {customerApi, healthcenterUserApi} from '@/container';
import Customer from "@/customer/interfaces/Customer";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import ApplicationMobileHeader
    from "@/customer/components/application-mobile/application-mobile-header/ApplicationMobileHeader.vue";
import CustomerApplicationMobileAttachmentsBanner
    from "@/customer/components/application-mobile/customer-application-mobile-attachments/CustomerApplicationMobileAttachmentsBanner.vue";
import TodayCustomersDatatable from "@/communication/components/TodayCustomersDatatable.vue";
import CertifiedCustomerCountCard from "@/patient-administration/components/application/CertifiedCustomerCountCard.vue";
import PendingUserCountCard from "@/patient-administration/components/application/PendingUserCountCard.vue";

const loading = ref<boolean>(false);
const customers = ref<Customer[]>([]);
const uncertifiedCustomers = ref<any[]>([]);
const meta = ref<any>();

onMounted(() => {
    loading.value = true;
    getCertifiedCustomers()
        .then(() => getPendingCertificationUsers())
        .finally(() => {
            loading.value = false;
        });
});

/**
 * Get certified customers.
 */
const getCertifiedCustomers = async () => {
    return customerApi().get({certified: true, limit: 1})
        .then(response => {
            customers.value = response.data;
            meta.value = response.meta;
        });
};

/**
 * Get user which have a pending certification.
 *
 * @return {Promise}
 */
const getPendingCertificationUsers = () => {
    return healthcenterUserApi().index({certification_status: 'pending'})
        .then(response => {
            uncertifiedCustomers.value = response;
        });
};
</script>
